import React from "react";

export default function Odstep({ size = 32 }) {
  return (
    <div style={{ height: size }} aria-hidden="true" />
  );
}
